import { Pagination, PostsOrPages, Tags } from "@tryghost/content-api";
import { BlogPagination } from "../../../components/BlogPagination";
import { BlogPostPreview } from "../../../components/BlogPostPreview";
import { BlogTagsDisplay } from "../../../components/BlogTagsDisplay";
import { MarketingFooter } from "../../../components/MarketingFooter";
import { MarketingMenu } from "../../../components/MarketingMenu";
import { MarketingOGTags } from "../../../components/MarketingOGTags";
import { FadeUpContainer } from "../../../components/ReusableStyledComponents/FadeUp";
import { VerticalSpacing } from "../../../components/VerticalSpacing";
import { BlogGenericWrapper, BlogPageHeaderComponentWrapper, PostPreviewGrid, TagDisplayContainer } from "./BlogGenericPageLayout.styles";

import type { JSX } from "react";

interface BlogGenericPageLayoutProps {
    postOrPages: PostsOrPages;
    tags?: Tags;
    pagination: Pagination;
    headerComponent?: JSX.Element;
    paginationPrefix?: string;
    activeTag?: string;
    title?: string;
    description?: string;
    canonicalUrl: string;
    forceNoRobot?: boolean;
}

export const BlogGenericPageLayout = ({
    postOrPages,
    tags,
    headerComponent,
    pagination,
    paginationPrefix,
    activeTag,
    title,
    description,
    canonicalUrl,
    forceNoRobot = false
}: BlogGenericPageLayoutProps) => (
    <>
        <MarketingOGTags title={title} description={description} canonicalUrl={canonicalUrl} forceNoRobot={forceNoRobot} />
        <MarketingMenu />
        <FadeUpContainer $bckgroundColor={!!headerComponent ? "#F5F8FF" : undefined}>
            {!!headerComponent && (
                <BlogPageHeaderComponentWrapper>
                    <BlogGenericWrapper>{headerComponent}</BlogGenericWrapper>
                </BlogPageHeaderComponentWrapper>
            )}
            <VerticalSpacing bottom={50} top={!!headerComponent ? 0 : 40}>
                <TagDisplayContainer>{!!tags && <BlogTagsDisplay tags={tags} activeTag={activeTag} />}</TagDisplayContainer>
            </VerticalSpacing>
            <BlogGenericWrapper>
                <PostPreviewGrid>
                    {postOrPages.map((post) => (
                        <div key={post.id}>
                            {" "}
                            <BlogPostPreview post={post} />
                        </div>
                    ))}
                </PostPreviewGrid>
            </BlogGenericWrapper>
            <BlogPagination pagination={pagination} paginationPrefix={paginationPrefix} />
        </FadeUpContainer>
        <MarketingFooter useNextRouter={false} />
    </>
);
